document.addEventListener('DOMContentLoaded', () => {
  const variantsData = document.getElementById('dk-variants');
  if (!variantsData) return;

  const $ = (selector) => document.querySelector(selector);
  const $$ = (selector) => Array.from(document.querySelectorAll(selector));
  const variants = JSON.parse(variantsData.textContent);
  const photos = {};
  $$('.dk-thumb').forEach((button) => {
    const img = button.querySelector('img');
    if (img) photos[button.dataset.variantId] = { src: img.currentSrc || img.src, srcset: img.srcset };
  });

  const heroImage = $('#hero-image');
  const caption = $('#gallery-caption');
  const mainButton = $('#main-add');
  const ctaPrice = $('#cta-price');
  const sticky = $('#sticky-buy');
  const stickyButton = $('#sticky-add');
  const stickyVariant = $('#sticky-variant');
  const stickySummary = $('#sticky-summary');
  const stickyImage = $('#sticky-image');
  const shippingCopy = $('#shipping-copy');
  const liveStatus = $('#live-status');

  const selectedInput = () => $('.dk-product-form input[name="id"]:checked');
  const selectedVariant = () => {
    const input = selectedInput();
    return input && variants[input.value] ? { id: input.value, ...variants[input.value] } : null;
  };

  const setImage = (img, photo) => {
    if (!img || !photo) return;
    if (photo.srcset) img.srcset = photo.srcset;
    else img.removeAttribute('srcset');
    img.src = photo.src;
  };

  const showPhoto = (variantId) => {
    const photo = photos[variantId];
    const variant = variants[variantId];
    if (!photo || !variant) return;
    setImage(heroImage, photo);
    if (caption) {
      const suffix = caption.dataset.suffix;
      caption.textContent = suffix ? `${variant.title} · ${suffix}` : variant.title;
    }
    $$('.dk-thumb').forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.variantId === String(variantId))));
  };

  const updateSticky = () => {
    if (!sticky || !mainButton || !stickyButton) return;
    const buttonRect = mainButton.getBoundingClientRect();
    const beforePurchase = buttonRect.top > window.innerHeight - 70;
    const visible = (window.innerWidth <= 760 && beforePurchase) || buttonRect.bottom < 95;
    const variant = selectedVariant();

    sticky.classList.toggle('dk-visible', visible);
    sticky.inert = !visible;
    sticky.setAttribute('aria-hidden', String(!visible));

    if (beforePurchase || !variant) {
      stickyButton.type = 'button';
      stickyButton.removeAttribute('data-add-to-cart');
      stickyButton.disabled = false;
      stickyButton.dataset.action = 'choose';
      stickyButton.textContent = stickyButton.dataset.chooseLabel;
    } else {
      stickyButton.type = 'submit';
      stickyButton.setAttribute('data-add-to-cart', '');
      stickyButton.disabled = !variant.available;
      stickyButton.dataset.action = 'add';
      stickyButton.textContent = `${stickyButton.dataset.addLabel} · ${variant.priceLabel}`;
    }
  };

  const selectVariant = (input) => {
    if (!input) return;
    input.checked = true;
    const variant = selectedVariant();
    if (!variant) return;

    if (ctaPrice) ctaPrice.textContent = variant.priceLabel;
    if (mainButton) mainButton.disabled = !variant.available;
    if (stickyVariant) stickyVariant.value = variant.id;
    if (stickySummary) stickySummary.textContent = `${variant.title} · ${variant.priceLabel}`;
    setImage(stickyImage, photos[variant.id]);
    if (shippingCopy) {
      shippingCopy.textContent = variant.count === 1 ? shippingCopy.dataset.single : shippingCopy.dataset.multi;
    }
    showPhoto(variant.id);
    updateSticky();
    if (liveStatus) liveStatus.textContent = `${variant.title} selected, ${variant.priceLabel}.`;
  };

  $$('.dk-product-form input[name="id"]').forEach((input) => {
    input.addEventListener('change', () => selectVariant(input));
  });

  $$('.dk-thumb').forEach((button) => {
    button.addEventListener('click', () => showPhoto(button.dataset.variantId));
  });

  $$('[data-select-variant]').forEach((button) => {
    button.addEventListener('click', () => {
      selectVariant($(`.dk-product-form input[name="id"][value="${button.dataset.selectVariant}"]`));
    });
  });

  if (stickyButton) {
    stickyButton.addEventListener('click', (event) => {
      if (stickyButton.dataset.action !== 'choose') return;
      event.preventDefault();
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      $('#purchase').scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
      const checked = selectedInput();
      if (checked) checked.focus({ preventScroll: true });
    });
  }

  $$('[data-dk-open-detail]').forEach((link) => {
    link.addEventListener('click', () => {
      const target = document.querySelector(link.getAttribute('href'));
      if (target && target.tagName === 'DETAILS') target.open = true;
    });
  });

  const refreshCartCount = () => {
    const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((cart) => {
        $$('[data-dk-cart-count]').forEach((badge) => {
          badge.textContent = cart.item_count;
          badge.hidden = cart.item_count === 0;
        });
      })
      .catch(() => {});
  };

  const cartButtons = $$('.dk-lp [data-add-to-cart]');
  cartButtons.forEach((button) => {
    button.dataset.dkUnavailable = String(button.disabled);
  });

  const restoreCartButtons = () => {
    cartButtons.forEach((button) => {
      if (button !== mainButton && button !== stickyButton) button.disabled = button.dataset.dkUnavailable === 'true';
    });
    const variant = selectedVariant();
    if (mainButton && variant) mainButton.disabled = !variant.available;
    updateSticky();
  };

  ['theme:cart:added', 'theme:cart:close'].forEach((eventName) => {
    document.addEventListener(eventName, () => {
      refreshCartCount();
      window.setTimeout(refreshCartCount, 2000);
      restoreCartButtons();
    });
  });

  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  selectVariant(selectedInput());
});
